import {Component, OnInit} from '@angular/core';
import {AbstractQuoteRow} from '../../abstract-quote-row';

@Component({
  selector: 'app-service-quote-row',
  templateUrl: './service-quote-row.component.html',
  styleUrls: ['./service-quote-row.component.css']
})
export class ServiceQuoteRowComponent extends AbstractQuoteRow<number> implements OnInit {
  manualCover = 0;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  getRowObject(): number {
    return this.manualCover;
  }

}
